var _defineProperty = require("/Users/bene/dev/mdx-live-editor/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/Users/bene/dev/mdx-live-editor/node_modules/@babel/runtime/helpers/slicedToArray");

var toStyleObject = require('to-style').object;

var _require = require('change-case'),
    paramCase = _require.paramCase;

var _require2 = require('./util'),
    toTemplateLiteral = _require2.toTemplateLiteral; // eslint-disable-next-line complexity


function toJSX(node) {
  var parentNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$skipExport = options.skipExport,
      skipExport = _options$skipExport === void 0 ? false : _options$skipExport,
      _options$preserveNewl = options.preserveNewlines,
      preserveNewlines = _options$preserveNewl === void 0 ? false : _options$preserveNewl;
  var children = '';

  if (node.properties != null) {
    if (typeof node.properties.style === 'string') {
      node.properties.style = toStyleObject(node.properties.style, {
        camelize: true
      });
    } // AriaProperty => aria-property
    // dataProperty => data-property


    var paramCaseRe = /^(aria[A-Z])|(data[A-Z])/;
    node.properties = Object.entries(node.properties).reduce(function (properties, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return Object.assign({}, properties, _defineProperty({}, paramCaseRe.test(key) ? paramCase(key) : key, value));
    }, {});
  }

  if (node.type === 'root') {
    var importNodes = [];
    var exportNodes = [];
    var jsxNodes = [];
    var layout;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var childNode = _step.value;

        if (childNode.type === 'import') {
          importNodes.push(childNode);
          continue;
        }

        if (childNode.type === 'export') {
          if (childNode.default) {
            layout = childNode.value.replace(/^export\s+default\s+/, '').replace(/;\s*$/, '');
            continue;
          }

          if (/^export\s{\s?default\s?}\sfrom/.test(childNode.value) || /^export\s{.*?as\sdefault\s?}/.test(childNode.value)) {
            var example = void 0; // eslint-disable-next-line max-depth

            if (/\}\s*from\s+/.test(childNode.value)) {
              example = "\n              For example, instead of:\n\n              export { default } from './Layout'\n\n              use:\n\n              import Layout from './Layout'\n              export default Layout\n            ".trim();
            } else {
              example = "\n              For example, instead of:\n\n              export { Layout as default }\n\n              use:\n\n              export default Layout\n            ".trim();
            }

            throw new Error("\n            MDX doesn't support using \"default\" as a named export, use \"export default\" statement instead.\n\n            ".concat(example, "\n          ").trim().replace(/^ +/gm, ''));
          }

          exportNodes.push(childNode);
          continue;
        }

        jsxNodes.push(childNode);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var exportNames = exportNodes.map(function (node) {
      return node.value.match(/export\s*(var|const|let|class|function)?\s*(\w+)/);
    }).map(function (match) {
      return Array.isArray(match) ? match[2] : null;
    }).filter(Boolean);
    return importNodes.map(function (childNode) {
      return toJSX(childNode, node);
    }).join('\n') + '\n' + exportNodes.map(function (childNode) {
      return toJSX(childNode, node);
    }).join('\n') + '\n' + "const layoutProps = {\n  ".concat(exportNames.join(',\n'), "\n};\n").concat(skipExport ? '' : 'export default', " class MDXContent extends React.Component {\n  constructor(props) {\n    super(props)\n    this.layout = ").concat(layout || 'null', "\n  }\n  render() {\n    const { components, ...props } = this.props\n\n    return <MDXTag\n             name=\"wrapper\"\n             ").concat(layout ? "Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}" : '', "\n             components={components}>").concat(jsxNodes.map(function (childNode) {
      return toJSX(childNode, node);
    }).join(''), "\n           </MDXTag>\n  }\n}\nMDXContent.isMDXComponent = true");
  } // Recursively walk through children


  if (node.children) {
    children = node.children.map(function (childNode) {
      var childOptions = Object.assign({}, options, {
        // Tell all children inside <pre> tags to preserve newlines as text nodes
        preserveNewlines: preserveNewlines || node.tagName === 'pre'
      });
      return toJSX(childNode, node, childOptions);
    }).join('');
  }

  if (node.type === 'element') {
    var props = '';

    if (Array.isArray(node.properties.className)) {
      node.properties.className = node.properties.className.join(' ');
    }

    if (Object.keys(node.properties).length > 0) {
      props = JSON.stringify(node.properties);
    }

    return "<MDXTag name=\"".concat(node.tagName, "\" components={components}").concat(parentNode.tagName ? " parentName=\"".concat(parentNode.tagName, "\"") : '').concat(props ? " props={".concat(props, "}") : '', ">").concat(children, "</MDXTag>");
  } // Wraps text nodes inside template string, so that we don't run into escaping issues.


  if (node.type === 'text') {
    // Don't wrap newlines unless specifically instructed to by the flag,
    // to avoid issues like React warnings caused by text nodes in tables.
    var shouldPreserveNewlines = preserveNewlines || parentNode.tagName === 'p';

    if (node.value === '\n' && !shouldPreserveNewlines) {
      return node.value;
    }

    return toTemplateLiteral(node.value);
  }

  if (node.type === 'comment') {
    return "{/*".concat(node.value, "*/}");
  }

  if (node.type === 'import' || node.type === 'export' || node.type === 'jsx') {
    return node.value;
  }
}

function compile() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  this.Compiler = function (tree) {
    return toJSX(tree, {}, options);
  };
}

module.exports = compile;
exports = compile;
exports.toJSX = toJSX;
exports.default = compile;